export enum TicketCategory {
  NEW_BRAND_SUPPLIER_ONBOARDING = 'New Brand/Supplier Onboarding',
  ADDITIONAL_SUPPLIER_BRANCH_ONBOARDING = 'Additional Supplier/Branch Onboarding',
  CMS_UPDATE = 'CMS Update',
  CATALOG_RELATED = 'Catalog Related',
  LOGISTIC_FULFILLMENT_REQUEST = 'Logistics Fulfillment Request',
  ORDER_RELATED = 'Order Related',
  OTHER_REQUESTS_INQUIRIES = 'Other Requests/Inquiries',
}
